<template>
  <div class="groupWebsiteEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnGroupNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem :label="$t('lang.lab_titleGroupNews')" prop="title">
          <el-input v-model="ruleForm.title" :placeholder="$t('lang.lab_fillinGroupNewsication')" class="item-input"
            maxlength="50"></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_image')" prop="imageUri" ref="imageUri">
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears'
            @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item :label="$t('lang.lab_contentGroupNews')" prop="content" class="editor-width">
          <quill-editor v-model="ruleForm.content" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span class="editorText"
            v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
          <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:groupWebsiteEdit
   *@Description:集团官网维护新闻 编辑/新增
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2021-08-11
   */
  // 引入富文本title汉字
  import {
    addQuillTitle
  } from '../../../config/quill-title.js'
  import {
    mapGetters
  } from 'vuex'
  import UploadFile from '../../../components/upload_file.vue'
  export default {
    data() {
      return {
        accept: '.jpg, .jpeg, .png',
        fileList: [],
        clears: false,
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        saveData: '',
        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        isTrue: true, // 数据已定义
        isFalse: false, // 数据未定义
        isLength: 0, // 富文本字数长度
        rules: {
          title: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectTitleGroupNews'),
            trigger: 'blur'
          }],
          content: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectGroupNewscation'),
            trigger: 'blur'
          }],
        },
        ruleForm: {
          id: '', // 序号
          title: '', // 新闻主题
          imageUri: '', // 新闻图片
          content: '', // 新闻正文
        },
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{
                header: 1
              }, {
                header: 2
              }], // 标题，键值对的形式；1、2表示字体大小
              [{
                list: 'ordered'
              }, {
                list: 'bullet'
              }], // 列表
              [{
                script: 'sub'
              }, {
                script: 'super'
              }], // 上下标
              [{
                indent: '-1'
              }, {
                indent: '+1'
              }], // 缩进
              [{
                direction: 'rtl'
              }], // 文本方向
              [{
                size: ['small', false, 'large', 'huge']
              }], // 字体大小
              [{
                header: [1, 2, 3, 4, 5, 6, false]
              }], // 几级标题
              [{
                color: []
              }, {
                background: []
              }], // 字体颜色，字体背景颜色
              [{
                font: []
              }], // 字体
              [{
                align: []
              }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ]
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text'),
        }
      }
    },
    components: {
      'upload-file': UploadFile
    },
    computed: {
      ...mapGetters(['gardenId']),
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    destroyed() {
      window.localStorage.setItem('jtxwform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('jtxwsaveData', JSON.stringify(this.saveData))
    },
    created() {
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (this.isFlag) {
        this.getData()
      }
      if (window.localStorage.getItem('jtxwform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('jtxwform'))
        if (window.localStorage.getItem('jtxwsaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('jtxwsaveData'))
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 获取组件值
      getFile(e) {
        this.ruleForm.imageUri = e
        this.$refs.imageUri.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.imageUri = ''
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'groupWebsiteList'
        })
      },
      // 新闻编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.id
        this.ruleForm.title = this.$route.query.object.newsTitle
        this.ruleForm.content = this.$route.query.object.newsContent
        this.ruleForm.imageUri = this.$route.query.object.newsImage
        if (this.ruleForm.imageUri) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.imageUri
          })
        }
        // 这是用来计算当前字符数，当有内容时，减去默认前后缀占位数
        var count = 0
        if (this.ruleForm.content != '') {
          count = 7
        }
        this.isLength = this.ruleForm.content.length - count
        console.log('getData', this.ruleForm)
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
      },

      // 保存
      save(formName) {
        console.log('save', this.ruleForm)
        let params = {}
        params.newsTitle = this.ruleForm.title
        params.newsContent = this.ruleForm.content
        params.newsImage = this.ruleForm.imageUri
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (this.isFlag) {
              // 编辑
              params.id = this.ruleForm.id
              this.$patch(`/groupNewsEdit`, params).then(
                res => {
                  console.log(res)
                  loading.close()
                  if (res && res.err === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'groupWebsiteList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 新增
              this.$post('/groupNewsAdd', params).then(
                res => {
                  console.log(res)
                  loading.close()
                  if (res && res.err === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.$router.push({
                      name: 'groupWebsiteList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.content === '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },
      // 清空
      resetForm(formName) {
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.title = '' // 新闻主题
        this.ruleForm.content = '' // 新闻正文
      },
    },
    // 富文本字数限制显示位置
    mounted() {
      addQuillTitle()
    }
  }
</script>

<style lang="scss">
  .proprietorNotificationEdit {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>